// 获取oss的私有地址
import request from "~/utils/request";
import {BATCH_FILE_URL, PRIVATE_FILE_URL} from "~/api/api-list";

// 获取oss的私有地址
export function getPrivateOss(params) {
  return request({
    url: PRIVATE_FILE_URL,
    method: 'get',
    params: params,
    baseUrlType: 2
  });
}

// 获取oss的私有地址
export function postBatchFileUrls(data) {
  return request({
    url: BATCH_FILE_URL,
    method: 'post',
    data,
    baseUrlType: 2
  });
}
